<template>
	<button :disabled="loading || disabled" @click="$emit('click', $event)">
		<span class="flex items-center gap-8">
			<BaseIcon v-if="loading" name="mono/load" />
			<slot v-else-if="$slots.icon" name="icon" />
			<slot />
		</span>
	</button>
</template>

<script>
export default {
	props: {
		loading: Boolean,
		disabled: Boolean,
	},
	emits: ['click'],
}
</script>
